import Vue from 'vue'
Vue.prototype.$moduleConfiguration = {
  tailored: {
    materials: {
      Pel: 'Pel',
      Acc: 'Acc',
      Mor: 'Mor',
      Pun: 'Pun',
      Mod: 'Mod',
      Mat: 'Mat',
      Sug: 'Sug',
      PaS: 'PaS',
      Pat: 'Pat',
      Moi: 'Moi',
      Sup_plan: 'Sup_plan',
      Riv_plan: 'Riv_plan',
      Mez: 'Mez',
      Pelo: 'Pelo',
      reinforcement: 'reinforcement',
      noVariants: [],
    },
    models: 'models',
    tagColor: 'is-primary',
    catalogType: 'catalog',
    claimHasProdDetails: true,
    minPel: 1,
    maxPel: 5,
    minRip: 0,
    maxRip: 0,
    isAccArray: false,
    modelHasShapes: false,
    modelHasSecondaryPrev: false,
    modelHasDescription: false,
    modelHasFodera: true,
    modelHasAllacciatura: true,
    modelHasDetails: false,
    modelHasTomaio: true,
    modelHasRiporti: false,
    modelHasSole: true,
    modelHasRifinitura: true,
    modelHasAllestimento: true,
    modelHasGender: true,
    modelHasSeason: true,
    modelHasLowHigh: true,
    modelHasDime: false,
    hasCustomTomaiaDrills: true,
    hasRestrictedAllestimentoTomaia: false,
    bdictionary: 'bdictionary',
    ddictionary: 'ddictionary',
    bdictionaryName: 'bDictionaryName',
    ddictionaryName: 'dDictionaryName',
    orderForm: 'order-form',
    orderHasShoeCatalogType: true,
    orderHasPatologies: true,
    orderHasPrecPair: true,
    orderHasShape: false,
    orderHasDigitalArchive: false,
    orderHasMeasurementsNotes: true,
    claimHasOrderType: true,
    isMeasurementRequired: key => key !== key,
  },
  fits: {
    materials: {
      Pel: 'Pel_F',
      Acc: 'Acc_F',
      All: 'All_F',
      Fog: 'Fog_F',
      Pun: 'Pun_F',
      Col: 'Col_F',
      PaS: 'PaS_F',
      Pat: 'Pat_F',
      noVariants: ['Fog_F', 'Pun_F', 'Col_F', 'All_F'],
    },
    models: 'models_F',
    shapes: 'shapes',
    soles: 'soles',
    catalogType: 'catalog_fits',
    claimHasProdDetails: true,
    tagColor: '',
    shapesByGender: false,
    minPel: 4,
    maxPel: 4,
    isAccArray: true,
    soleHasCorrections: true,
    soleHasCustomSizes: true,
    soleHasRialzi: false,
    soleHasCampanatura: false,
    soleHasSperonatura: false,
    modelHasShapes: false,
    modelHasFodera: true,
    modelHasAllacciatura: true,
    modelHasCustomSizes: false,
    modelHasGender: true,
    modelHasSeason: true,
    modelHasLowHigh: true,
    modelHasTomaio: true,
    modelHasDetails: false,
    modelHasRiporti: false,
    modelHasSole: true,
    modelHasRifinitura: false,
    modelHasAllestimento: false,
    modelHasDescription: false,
    modelHasDime: false,
    hasSecondaryPrev: false,
    hasCustomTomaiaDrills: true,
    hasRestrictedAllestimentoTomaia: false,
    bdictionary: 'bdictionary_fits',
    ddictionary: 'ddictionary_fits',
    bdictionaryName: 'bDictionaryNameFits',
    ddictionaryName: 'dDictionaryNameFits',
    orderForm: 'order-form-fits',
    orderHasShoeCatalogType: true,
    orderHasPatologies: true,
    orderHasPrecPair: false,
    orderHasShape: false,
    orderHasDigitalArchive: false,
    orderHasTomaiaConfig: true,
    orderHasMeasurementsNotes: true,
    getOrderContraffortiType: (shoeType, hasFortiAlti = true) => {
      const types = ['Noone', 'calc', 'short', 'pro_med', 'pro_lat', 'pro_bi']
      const highTypes = ['high_bi', 'medial', 'sidal', 'total', 'peronoic']
      return shoeType === 'high' && hasFortiAlti ? [...types, ...highTypes] : types
    },
    isMeasurementRequired: key => key !== key,
    claimHasOrderType: false,
  },
  modular: {
    materials: {
      Pel: 'Pel_M',
      Rip: 'Rip_M',
      Fog: 'Fog_M',
      Pun: 'Pun_M',
      Col: 'Col_M',
      noVariants: ['Fog_M', 'Pun_M', 'Col_M'],
    },
    models: 'models_M',
    shapes: 'shapes_M',
    soles: 'soles_M',
    catalogType: 'catalog_modular',
    claimHasProdDetails: true,
    tagColor: 'is-secondary',
    shapesByGender: true,
    minPel: 1,
    maxPel: 5,
    minRip: 0,
    maxRip: 3,
    isAccArray: false,
    soleHasCorrections: false,
    soleHasCustomSizes: false,
    soleHasRialzi: true,
    soleHasCampanatura: true,
    soleHasSperonatura: true,
    hasSecondaryPrev: true,
    modelHasShapes: true,
    modelHasCustomSizes: true,
    modelHasSole: true,
    modelHasFodera: false,
    modelHasDescription: true,
    modelHasRifinitura: false,
    modelHasAllestimento: false,
    modelHasGender: true,
    modelHasSeason: true,
    modelHasLowHigh: true,
    modelHasTomaio: true,
    modelHasDetails: true,
    modelHasRiporti: true,
    modelHasDime: false,
    hasCustomTomaiaDrills: false,
    hasRestrictedAllestimentoTomaia: true,
    bdictionary: 'bdictionary_modular',
    ddictionary: 'ddictionary_modular',
    bdictionaryName: 'bDictionaryNameModular',
    ddictionaryName: 'dDictionaryNameModular',
    orderForm: 'order-form-modular',
    orderHasShoeCatalogType: true,
    orderHasPatologies: false,
    orderHasPrecPair: false,
    orderHasShape: true,
    orderHasDigitalArchive: true,
    orderHasTomaiaConfig: false,
    orderHasSeason: true,
    orderHasMeasurementsNotes: false,
    getOrderContraffortiType: (shoeType, hasFortiAlti) => {
      const types = ['Noone', 'calc']
      const highTypes = ['Noone', 'calc', 'high_bi', 'high_medial', 'high_sidal']
      return shoeType === 'high' && hasFortiAlti ? highTypes : types
    },
    isMeasurementRequired: key => ['ball', 'instep_italy', 'heel'].includes(key),
    claimHasOrderType: false,
  },
  insole: {
    materials: {
      Moi: 'Moi_I',
      Ric_plan: 'Ric_plan_I',
      Rie_plan: 'Rie_plan_I',
      Ins: 'Ins_I',
      noVariants: [],
    },
    models: 'models_I',
    catalogType: 'catalog_insole',
    claimHasProdDetails: false,
    tagColor: 'is-insole',
    shapesByGender: false,
    minPel: 0,
    maxPel: 0,
    minRip: 0,
    maxRip: 0,
    isAccArray: false,
    soleHasCorrections: false,
    soleHasCustomSizes: false,
    soleHasRialzi: false,
    soleHasCampanatura: false,
    soleHasSperonatura: false,
    hasSecondaryPrev: false,
    modelHasShapes: false,
    modelHasCustomSizes: true,
    modelHasSole: false,
    modelHasFodera: false,
    modelHasDescription: false,
    modelHasGender: false,
    modelHasSeason: false,
    modelHasLowHigh: false,
    modelHasTomaio: false,
    modelHasDetails: false,
    modelHasRiporti: false,
    modelHasRifinitura: false,
    modelHasAllestimento: false,
    modelHasDime: true,
    hasCustomTomaiaDrills: false,
    hasRestrictedAllestimentoTomaia: false,
    bdictionary: 'bdictionary_insole',
    ddictionary: 'ddictionary_insole',
    bdictionaryName: 'bDictionaryNameInsole',
    ddictionaryName: 'dDictionaryNameInsole',
    orderForm: 'order-form-insole',
    orderHasShoeCatalogType: false,
    orderHasPatologies: true,
    orderHasPrecPair: true,
    orderHasPairSelector: true,
    orderHasShape: false,
    orderHasDigitalArchive: false,
    orderHasTomaiaConfig: false,
    orderHasSeason: false,
    orderHasMeasurementsNotes: true,
    getOrderContraffortiType: () => {},
    isMeasurementRequired: key => ['ball', 'instep_italy', 'heel'].includes(key),
    claimHasOrderType: false,
  },
}
